// import React from "react";
// import GalleryCTR from "../containers/gallery/GalleryCTR"; 

// function Gallery() {
//   return (
//     <>
//       <GalleryCTR />
//     </>
//   );
// }

// export default Gallery;


import React from "react";
import { Helmet } from 'react-helmet-async';

import GalleryCTR from "../containers/gallery/GalleryCTR";

function Gallery() {
  return (
    <>
      <Helmet>
        <title>Dubai Tour Gallery | Desert Safari Photos | Bonvoy Tourism</title>
        <meta
          name="description"
          content="Browse stunning photos from Bonvoy Tourism's desert safaris, city tours and adventures across Dubai and the UAE. See what awaits you — book your tour today."
        />
        <link rel="canonical" href="https://bonvoytourism.com/gallery" />
      </Helmet>

      <GalleryCTR />
    </>
  );
}

export default Gallery;